import { makeStyles } from '@mui/styles';
import { COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  title: {
    color: COLOR_PURPLE,
    fontSize: 18,
    textAlign: 'center',
  },
  mainBoxImages: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '12px',
    paddingBottom: theme.spacing(1),
  },
}));
